import { call, put, takeEvery } from 'redux-saga/effects';
import { setProvider } from './reducer';
import { ProviderType } from 'src/types/provider';
import { getProvider } from './functions';

function* initProvider(action: { type: string; payload: ProviderType[] }) {
    const provider = getProvider(action.payload);

    if (!localStorage.getItem('eshopKey')) {
        yield call(() => {
            if (provider.ESHOP_KEY) {
                localStorage.setItem('eshopKey', provider.ESHOP_KEY);
                localStorage.setItem('eshopName', provider.COMPANY_NAME || '');
            }
        });
    }

    yield put(setProvider(provider));
}

export function* initProviderWatch() {
    yield takeEvery('provider/initProvider', initProvider);
}
